// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"4cf2cb3f","695":"210d93c6","902":"15364b30","933":"7f1a1ab0"}[chunkId] + ".chunk.js";
};